import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filter",
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;

    searchText = searchText.toLowerCase();

    return items.filter((item) => {
      return Object.keys(item).some((key) => {
        const value = item[key];
        if (value === null || value === undefined) return false;

        // Check if the value is a date and convert it to string for searching
        if (value instanceof Date) {
          return value.toISOString().toLowerCase().includes(searchText);
        }

        // Handle different types of values
        if (typeof value === "object") {
          // Skip objects for direct comparison
          return false;
        } else {
          return value.toString().toLowerCase().includes(searchText);
        }
      });
    });
  }
}
